import { render, staticRenderFns } from "./PermisoCierreCaja.vue?vue&type=template&id=7b179be1&scoped=true"
import script from "./PermisoCierreCaja.vue?vue&type=script&lang=js"
export * from "./PermisoCierreCaja.vue?vue&type=script&lang=js"
import style0 from "./PermisoCierreCaja.vue?vue&type=style&index=0&id=7b179be1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b179be1",
  null
  
)

export default component.exports